/**
 *  uiReducer reducer
 */

// Import Action Types
import { ActionTypes as uiActions } from '../actions/ui'

const initialState = {
  uploadBtnDisabled: true,
  alertFileSize: false,
  alertFileType: false,
}

export function uiReducer(state = initialState, action) {
  switch (action.type) {
    case uiActions.SHOW:
      return {
        ...state,
        [action.key]: true,
      }
    case uiActions.HIDE:
      return {
        ...state,
        [action.key]: false,
      }
    default:
      return state
  }
}

export default uiReducer
